import ValueFactory from './ValueFactory'
import ArrayValue from '../../models/values/ArrayValue'
import Value from '../../models/values/Value'
import DiagramVariableType from '../../../data/models/DiagramVariableType'

const arrayValueFactoryFactory = {
  create: <TItemValue extends Value>(
    type: DiagramVariableType,
    valueFactory: ValueFactory<TItemValue>
  ): ValueFactory<ArrayValue<TItemValue>> => ({
    type,
    tryCreateWithStringRepresentation: async (representation) => {
      const regex = new RegExp(
        /(([-0-9.a-z])|(\([-0-9.,]+\))|(\[[-0-9.(),]+]))+/g
      )

      const valueRepresentations = representation.match(regex)

      const values: TItemValue[] = []
      for (const valueRepresentation of valueRepresentations ?? []) {
        const value = await valueFactory.tryCreateWithStringRepresentation(
          valueRepresentation
        )
        values.push(value)
      }

      return new ArrayValue<TItemValue>(values)
    }
  })
}

export default arrayValueFactoryFactory
